import { render, staticRenderFns } from "./SocialPostEditor.vue?vue&type=template&id=6fc406b4&scoped=true&"
import script from "./SocialPostEditor.vue?vue&type=script&lang=js&"
export * from "./SocialPostEditor.vue?vue&type=script&lang=js&"
import style0 from "./SocialPostEditor.vue?vue&type=style&index=0&id=6fc406b4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fc406b4",
  null
  
)

export default component.exports